import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './app';
import './static/style/react.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
